import Swiper, { Navigation, Pagination } from 'swiper';

export const initHomePageSlider = () => {
    const slider = document.querySelector('.hero-slider .swiper-container');
    if (!slider) return;
    const hasMultipleSlides = slider.querySelectorAll('.swiper-slide').length > 1;

    const swiper = new Swiper(slider, {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        loop: hasMultipleSlides,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });

    // Loop mode clones slides (only when there are several), which would duplicate the page's <h1>. Keep it in the original slide.
    swiper.el.querySelectorAll('.swiper-slide-duplicate h1').forEach((h1) => {
        const div = document.createElement('div');
        div.className = h1.className;
        div.innerHTML = h1.innerHTML;
        h1.replaceWith(div);
    });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			slidesPerView: 1,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
		});
	});
};

export const initGalleryElementCarousel2 = () => {
	document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			spaceBetween: 8,
			slidesPerView: 2,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
			breakpoints: {
				639: {
					slidesPerView: 3
				},
				1023: {
					slidesPerView: 4
				}
			}
		});
	});
};

export const initReferenceGallery = () => {
    document.querySelectorAll('.js-reference-gallery').forEach(function (carousel) {
        new Swiper(carousel, {
            modules: [Navigation],
            speed: 400,
            spaceBetween: 8,
            slidesPerView: 1.2,
            navigation: {
                nextEl: carousel.parentNode.querySelector('.js-reference-gallery-next'),
                prevEl: carousel.parentNode.querySelector('.js-reference-gallery-prev'),
            },
            breakpoints: {
                639: {
                    slidesPerView: 3
                },
                1023: {
                    slidesPerView: 4
                }
            }
        });
    });
};
